<template>
    <ims-page v-if="isReady" :requireLogin="true">
        <!-- Page Header -->
        <template v-slot:header>
            <ims-toolbar>
                <template v-slot:left>
                    <ims-back-button />
                </template>

                <div class="title" v-if="race && league">
                    <div class="text-sm text-fade">{{ race.name }}</div>
                    <div class="text-md">{{ league.name }}</div>
                </div>
                <!-- <span class="title md">{{ league.name }}</span> -->
            </ims-toolbar>
            <!-- Tab Bar -->
        </template>
        <main class="league-race">
            <ims-item class="p-2 no-border">
                <template v-slot:left>
                    <div class="race-logo"
                         :style="`background-image:url(${race.logoUrl});`"></div>
                </template>
                <span class="text-bold text-xl text-center">
                    {{ overallRank | ordinal }}
                </span>
                <template v-slot:right>
                    <ims-badge v-if="race.status == $AppConfig.status.IN_PROGRESS"
                               color="red"
                               size="sm">LIVE</ims-badge>
                    <ims-badge size="sm"
                               v-else-if="race.status == $AppConfig.status.COMPLETE">FINISHED</ims-badge>
                    <ims-badge size="sm"
                               v-else-if="race.status == $AppConfig.status.PRE_EVENT"
                               color="blue">WAITING</ims-badge>
                    <ims-badge size="sm"
                               v-else-if="race.status == $AppConfig.status.PRE_RACE"
                               color="green">OPEN</ims-badge>
                </template>
            </ims-item>
            <ims-meter v-if="race.status == $AppConfig.status.IN_PROGRESS"
                       class="m-3"
                       :total="race.totalLaps"
                       :current="race.lapsCompleted">
                <span>Lap {{ race.lapsCompleted }} of {{ race.totalLaps }}</span>
            </ims-meter>

            <!-- Standings Grid -->
            <section class="standings-grid">
                <!-- Leagues Around Ranking -->
                <ims-item class="divider">
                    <div class="ims-row">
                        My Ranking <ims-spinner :size="16" v-if="loading" />
                        <div class="filler" />
                        <!-- TODO: Replace with IN PROGRESS -->
                        <span class="text-xs"
                              v-if="
                race.status == $AppConfig.status.IN_PROGRESS &&
                  $AppConfig.refreshLeagueRace
              ">
                            refresh on
                        </span>
                    </div>
                </ims-item>
                <ims-item class="pad ims-item-last" v-if="!aroundMe.length">
                    <h1>Not Available</h1>
                </ims-item>
                <ims-item v-for="(team, index) in aroundMe"
                          class="compact"
                          :key="index"
                          :to="race.status == $AppConfig.status.COMPLETE || race.status == $AppConfig.status.IN_PROGRESS ? `/leagues/${team.leagueId}/races/${team.raceId}/team/${team.userId}` : ``"
                          :class="index == aroundMe.length - 1 ? 'ims-item-last' : ''">
                    <template v-slot:left>
                        <ims-badge size="sm" :color="team.isUser ? 'green' : 'blue'">
                            {{ team.rank }}
                        </ims-badge>
                    </template>
                    <span>{{ team.teamName }}</span>
                    <template v-slot:right>
                        <span>{{ team.totalPoints }}</span>
                    </template>
                </ims-item>
            </section>
            <section class="standings-grid">
                <ims-item class="divider">All Rankings</ims-item>
                <ims-item class="pad ims-item-last" v-if="!top.length">
                    <h1>Not Available</h1>
                </ims-item>
                <template>
                    <ims-item v-for="(team, index) in top"
                              class="compact"
                              :key="index"
                              :to="race.status == $AppConfig.status.COMPLETE || race.status == $AppConfig.status.IN_PROGRESS ? `/leagues/${team.leagueId}/races/${team.raceId}/team/${team.userId}` : ``"
                              :class="index == top.length - 1 ? 'ims-item-last' : ''">
                        <template v-slot:left>
                            <ims-badge size="sm" :color="team.isUser ? 'green' : 'blue'">
                                {{ team.rank }}
                            </ims-badge>
                        </template>
                        <span>{{ team.teamName }}</span>
                        <template v-slot:right>
                            <span>{{ team.totalPoints }}</span>
                        </template>
                    </ims-item>
                </template>
            </section>
        </main>
    </ims-page>
</template>

<script>
    import tick from '../modules/tick/tick';

    export default {
        data() {
            return {
                isTotals: true,
                league: null,
                race: null,
                ranks: [],
                top: [],
                aroundMe: [],
                loading: false,
                interval: null
            };
        },
        mounted() { },
        destroyed() {
            // Kill the reload interval if it exists
            this.stopAutoReload();
        },
        computed: {
            overallRank() {
                if (this.aroundMe.length) {
                    let me = this.aroundMe.find(row => {
                        return row.isUser;
                    });
                    if (me) {
                        return me.rank;
                    }
                }
                return 0;
            },
            isReady() {
                return this.$User.loggedIn && this.race && this.league;
            },
            // league() {
            //   return this.$store.getters.getLeague(this.$route.params.id);
            // },
            // race() {
            //   console.log('League Race', this.$store.state.races);
            //   return this.$store.getters.getRace(this.$route.params.raceid);
            // },
            totals() {
                return this.$store.state.leagues.totals;
            },
            sortedTeams() {
                let teams = this.race.teams;
                return (teams || []).sort((a, b) => {
                    return a.Rank > b.Rank ? 1 : -1;
                });
            }
        },
        watch: {
            '$store.state.user.loggedIn': {
                handler(loggedIn) {
                    if (loggedIn) {
                        this.init();
                    }
                },
                immediate: true
            }
        },
        methods: {
            /**
             * Load Race and League Data
             * from the API Service
             */
            async loadRaceAndLeagueData() {
                try {
                    this.league = await this.$User.service.getLeague(this.$route.params.id);
                    this.race = await this.$User.service.getRace(this.$route.params.raceid);
                } catch (e) {
                    this.$store.dispatch(
                        'interact/error',
                        `Sorry we're unable to load this race. Error: ${e.message}`
                    );
                }
            },
            /**
             * Load Data
             * if we have a race and league
             */
            async loadResults() {
                if (this.league && this.race) {
                    let standings = await this.$User.service.getRaceLeagueStandings(
                        this.race.id,
                        this.league.id
                    );
                    if (standings) {
                        this.aroundMe = standings.aroundMe;
                        this.top = standings.top;
                    }
                }
            },
            /**
             * Initialize the this view
             */
            async init() {
                let closeLoader = await this.$store.dispatch(
                    'loader/start',
                    'Looking up data...'
                );
                try {
                    // Load League and Race data once
                    await this.loadRaceAndLeagueData();
                    // Load standings at least once
                    await this.loadData();
                    // If status is in progress - start auto reload
                    if (this.race.status == this.$AppConfig.status.IN_PROGRESS) {
                        this.startAutoReload();
                    }
                } catch (e) {
                    this.$store.dispatch('interact/error', `${e.message}`);
                }
                closeLoader();
            },
            /**
             * Stand along data loader - for init and auto reload
             */
            async loadData() {
                // Set local loading for auto refreshing
                this.loading = true;
                // Load the Data from the services
                await this.loadResults();
                this.loading = false;
            },
            /**
             * Auto Load if race is in progress
             */
            async startAutoReload() {
                // Get time from config
                // Make sure it's more than 1000 otherwise it can
                // hit the API at an insane clip.
                let milliseconds = this.$AppConfig.refreshMS;
                milliseconds = milliseconds < 1000 ? 1000 : milliseconds;
                // If we have no interval running, and we're supposed to refresh the data
                if (!this.interval && this.$AppConfig.refreshLeagueRace) {
                    console.log('IMS:: Starting Auto Reload for Live Race');
                    // Set the interval
                    this.interval = setInterval(() => {
                        this.loadData();
                    }, milliseconds);
                }
            },
            /** Stop Reloading */
            async stopAutoReload() {
                clearInterval(this.interval);
            },
            // Get Teams
            teams() {
                return (
                    this.$store.getters.getRace(this.$route.params.raceid).Teams || []
                ).sort((a, b) => {
                    return a.Rank > b.Rank ? 1 : -1;
                });
            }
        }
    };
</script>

<style lang="scss">
    @import '../scss/utils/variables';

    .league-race {
        .race-logo

    {
        width: 46px;
        height: 46px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    }

    .league-race .standings-grid {
        .grid-header

    {
        font-size: 0.75em;
        text-transform: uppercase;
        font-weight: 700;
        & > *

    {
        min-height: 32px;
        padding-top: 0;
        padding-bottom: 0;
    }

    }

    .item-start {
        width: 60px;
    }
    }
</style>
